import { supabase, applyOrgFilter, getActiveOrgOverride, DEFAULT_ORG_ID } from '../supabaseClient'
import { getCurrentStaff } from './auth'

// Que prendas van en cada temporada. La necesidad del modulo de Uniformes sale de
// padron x esta tabla; antes salia del plan de pago y por eso el becado sin
// uniforme en su plan se volvia invisible.

const resolveOrgId = async () => {
  const { data: staff } = (await getCurrentStaff()) || {}
  return getActiveOrgOverride() || staff?.org_id || DEFAULT_ORG_ID
}

export const getTemporadaPrendas = async (temporadaId) => {
  try {
    if (!temporadaId) return { data: [], error: null }
    let query = supabase
      .from('temporada_prendas')
      .select('id, temporada_id, prenda_id, deporte, estatus, prendas:prenda_id(id, nombre, deporte, precio, tallas, personalizada)')
      .eq('temporada_id', temporadaId)
      .order('deporte')

    query = applyOrgFilter(query, getActiveOrgOverride() || null)
    const { data, error } = await query
    if (error) throw error
    return { data: data || [], error: null }
  } catch (error) {
    console.error('[getTemporadaPrendas]', error)
    return { data: [], error }
  }
}

export const addTemporadaPrenda = async ({ temporadaId, prendaId, deporte }) => {
  try {
    const orgId = await resolveOrgId()
    const { data, error } = await supabase
      .from('temporada_prendas')
      .insert({
        org_id: orgId,
        temporada_id: temporadaId,
        prenda_id: prendaId,
        deporte,
        estatus: 'abierta',
      })
      .select()
      .single()
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('[addTemporadaPrenda]', error)
    return { data: null, error }
  }
}

export const removeTemporadaPrenda = async (id) => {
  try {
    let query = supabase.from('temporada_prendas').delete().eq('id', id)
    query = applyOrgFilter(query, getActiveOrgOverride() || null)
    const { error } = await query
    if (error) throw error
    return { error: null }
  } catch (error) {
    console.error('[removeTemporadaPrenda]', error)
    return { error }
  }
}

export const setEstatusTemporadaPrenda = async (id, estatus) => {
  try {
    let query = supabase.from('temporada_prendas').update({ estatus }).eq('id', id)
    query = applyOrgFilter(query, getActiveOrgOverride() || null)
    const { error } = await query
    if (error) throw error
    return { error: null }
  } catch (error) {
    console.error('[setEstatusTemporadaPrenda]', error)
    return { error }
  }
}
